/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindCatalogProductsQueryResponse,
  FindCatalogProductsQueryParams,
} from "../types/FindCatalogProducts.ts"

export const findCatalogProductsQueryKey = (
  params: FindCatalogProductsQueryParams
) =>
  [
    { url: "/v1/product/find-catalog-products" },
    ...(params ? [params] : []),
  ] as const

export type FindCatalogProductsQueryKey = ReturnType<
  typeof findCatalogProductsQueryKey
>

/**
 * @summary Find catalog products
 * {@link /v1/product/find-catalog-products}
 */
export async function findCatalogProducts(
  params: FindCatalogProductsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCatalogProductsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-catalog-products`,
    params,
    ...requestConfig,
  })
  return res
}

export function findCatalogProductsQueryOptions(
  params: FindCatalogProductsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findCatalogProductsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindCatalogProductsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCatalogProductsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findCatalogProducts(params, config)
    },
  })
}

/**
 * @summary Find catalog products
 * {@link /v1/product/find-catalog-products}
 */
export function useFindCatalogProducts<
  TData = ResponseConfig<FindCatalogProductsQueryResponse>,
  TQueryData = ResponseConfig<FindCatalogProductsQueryResponse>,
  TQueryKey extends QueryKey = FindCatalogProductsQueryKey,
>(
  params: FindCatalogProductsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCatalogProductsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findCatalogProductsQueryKey(params)

  const query = useQuery(
    {
      ...findCatalogProductsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
